import { useTranslation } from "@opendash/i18n";
import { stringToTag } from "@opendash/ui";
import { Tooltip } from "antd";
import React from "react";
import { useTicketData } from "../..";

type Props = {};

export const IssueTag = (props: Props) => {
  const t = useTranslation();
  const { issuecategory } = useTicketData();

  const isEnabled = issuecategory?.get("enabled");

  return (
    <>
      {isEnabled &&
        stringToTag(
          `'${
            issuecategory?.name ??
            t("maintenance:ticket.description.items.nocategory")
          }'`,
          "'"
        )}
      {!isEnabled && (
        <Tooltip
          title={t("maintenance:ticket.description.items.category.notenabled")}
          color="red"
        >
          {stringToTag(
            `'${issuecategory?.name ?? t("maintenance:ticket.description.items.nocategory")}'`,
            "'",
            {
              color: "red",
              style: {
                cursor: "help",
              },
            }
          )}
        </Tooltip>
      )}
    </>
  );
};
